var _a;
import { TransactionStatus } from '../const/transactionStatus';
export var disputeOpenedTranslationKey = 'transactionStatus.disputeOpened';
export var disputeUnderReviewTranslationKey = 'transactionStatus.disputeUnderReview';
export var disputeDeniedTranslationKey = 'transactionStatus.disputeDenied';
export var disputeApprovedTranslationKey = 'transactionStatus.disputeApproved';
export var disputeCompletedTranslationKey = 'transactionStatus.disputeCompleted';
export var cancelationPendingTranslationKey = 'transactionStatus.cancelationPending';
var TransactionsStatusFlagTranslationKeys = (_a = {},
    _a[TransactionStatus.SET_1] = disputeOpenedTranslationKey,
    _a[TransactionStatus.SET_2] = disputeUnderReviewTranslationKey,
    _a[TransactionStatus.SET_3] = disputeUnderReviewTranslationKey,
    _a[TransactionStatus.SET_4] = disputeUnderReviewTranslationKey,
    _a[TransactionStatus.SET_5] = disputeUnderReviewTranslationKey,
    _a[TransactionStatus.SET_6] = disputeUnderReviewTranslationKey,
    _a[TransactionStatus.SET_7] = disputeUnderReviewTranslationKey,
    _a[TransactionStatus.SET_8] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_9] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_10] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_11] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_12] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_13] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_14] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_15] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_16] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_17] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_18] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_19] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_20] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_21] = cancelationPendingTranslationKey,
    _a[TransactionStatus.SET_22] = disputeUnderReviewTranslationKey,
    _a[TransactionStatus.SET_23] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_24] = disputeCompletedTranslationKey,
    _a[TransactionStatus.SET_25] = disputeCompletedTranslationKey,
    _a);
var getTranslationForTransactionStatus = function (status) {
    if (!TransactionsStatusFlagTranslationKeys[status]) {
        return null;
    }
    return TransactionsStatusFlagTranslationKeys[status];
};
export default getTranslationForTransactionStatus;
//# sourceMappingURL=getTranslationForTransactionStatus.js.map